"use strict";
window.addEventListener("DOMContentLoaded", ()=>{
    if (window.top !== window.self) {
        const sectionsToHide = document.querySelectorAll("body > *:not(#hero)");
        console.log(sectionsToHide);
        document.body.style.overflow = "hidden";
        console.log(Array.from(sectionsToHide).filter((section)=>{
            console.log(section.id);
            return section.id !== "features";
        }));
        Array.from(sectionsToHide).filter((section)=>{
            console.log(section.id);
            return section.id !== "features";
        }).filter((section)=>{
            console.log(section.id);
            return section.id !== "promotionTimer";
        }).forEach((section)=>{
            section.style.display = "none";
        });
    }
    const hero = document.getElementById("hero");
    const features = document.getElementById("features");
    const promotionTimer = document.getElementById("promotionTimer");
    window.addEventListener("resize", ()=>{
        window.parent.postMessage({
            type: "resize",
            height: ((hero === null || hero === void 0 ? void 0 : hero.scrollHeight) || 0) + ((features === null || features === void 0 ? void 0 : features.scrollHeight) || 0) + ((promotionTimer === null || promotionTimer === void 0 ? void 0 : promotionTimer.scrollHeight) || 0)
        }, "*");
    });
    window.parent.postMessage({
        type: "resize",
        height: ((hero === null || hero === void 0 ? void 0 : hero.scrollHeight) || 0) + ((features === null || features === void 0 ? void 0 : features.scrollHeight) || 0) + ((promotionTimer === null || promotionTimer === void 0 ? void 0 : promotionTimer.scrollHeight) || 0)
    }, "*");
    setTimeout(()=>{
        window.parent.postMessage({
            type: "resize",
            height: ((hero === null || hero === void 0 ? void 0 : hero.scrollHeight) || 0) + ((features === null || features === void 0 ? void 0 : features.scrollHeight) || 0) + ((promotionTimer === null || promotionTimer === void 0 ? void 0 : promotionTimer.scrollHeight) || 0)
        }, "*");
    }, 1000);
    window.clickToCTA = function(url) {
        window.parent.postMessage({
            type: "cta",
            url
        }, "*");
    };
});

//# sourceMappingURL=index.fd44763a.js.map
